<app-filter-fields
  [hasFilterTrigger]="hasFilterTrigger"
  [filterMode]="filterMode"
  [availableFilters]="getAvailableFilters()"
  [availableOrigins]="availableOrigins"
  [statusLeadFilters]="getStatusLeadFilters()"
  [selectedStatusLeadIdFilters]="getSelectedStatusLeadIdsFilters()"
  [adminFilterOptions]="adminFilterOptions"
  (searchChange)="onSearchChange($event)"
  (adminSearchChange)="onAdminSearchChange($event)"
  (orderChange)="onOrderChange($event)"
  (filterChange)="onFilterChange($event)"
  (filterStatusLeadChange)="onFilterStatusLeadChange($event)"
  (dateRangeChange)="onDateRangeChange($event)"
  (clearAllFilters)="onClearAllFilters()">
</app-filter-fields>

<!-- Loading Spinner -->
<div *ngIf="loading" class="loading-container">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- Error Message -->
<div *ngIf="errorMessage && !loading" class="error-container">
  <p class="error-message">{{ errorMessage }}</p>
</div>

<!-- Empty Message -->
<div *ngIf="!loading && !errorMessage && data.length === 0" class="empty-container">
  <p class="empty-message">{{ emptyMessage }}</p>
</div>

<!-- Tabela -->
<div class="table-container" *ngIf="!loading && !errorMessage && data.length > 0">
  <table mat-table [dataSource]="filteredPaginatedData" class="leads-table">
    <!-- Coluna de Ícones de Status -->
    <ng-container matColumnDef="statusIcon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div class="icons-container">
          <img *ngFor="let icon of getPreApprovedIcon(row.preAprovacao)" [src]="icon" class="icon">
          <img *ngFor="let icon of getRenewalIcon(row.renewal)" [src]="icon" class="icon">
        </div>
      </td>
    </ng-container>

    <!-- Colunas Dinâmicas -->
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef class="header-cell">
        <div class="header-content">
          <span>{{ column.label }}</span>
          <!-- Ícone de ordenação apenas para colunas de data -->
          <img
            *ngIf="isToggleSortColumn(column.key)"
            src="assets/icons/alphabeticalIcon.png"
            alt="Ordenar"
            class="sort-icon"
            [class.active]="getCurrentSortOrder(column.key)"
            [class.asc]="getCurrentSortOrder(column.key) === 'asc'"
            [class.desc]="getCurrentSortOrder(column.key) === 'desc'"
            (click)="toggleSortOrder(column.key)"
          >
          <!-- Indicador visual de ordenação -->
          <span
            *ngIf="isDateColumn(column.key) && !isToggleSortColumn(column.key) && getCurrentSortOrder(column.key)"
            class="sort-indicator"
            [class.asc]="getCurrentSortOrder(column.key) === 'asc'"
            [class.desc]="getCurrentSortOrder(column.key) === 'desc'"
          ></span>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container [ngSwitch]="column.type">
          <!-- Tipo Switch -->
          <div *ngSwitchCase="'switch'" class="switch-container">
            <div
              class="custom-switch"
              [class.disabled]="isSwitchDisabled(row, column.key)"
              (click)="onSwitchChange(row, column.key, {checked: !getSwitchState(row, column.key)})">
              <div class="switch-track" [class.active]="getSwitchState(row, column.key)">
                <div class="switch-thumb" [class.active]="getSwitchState(row, column.key)"></div>
              </div>
              <span class="switch-label">
                {{ getSwitchState(row, column.key) ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>

          <!-- Tipo Action -->
          <div *ngSwitchCase="'action'" class="action-container">
            <button
              class="action-button"
              [class.disabled]="isActionDisabled(row, column.key)"
              [disabled]="isActionDisabled(row, column.key)"
              (click)="onActionClick(row, column.key)">
              <img src="assets/icons/editIcon.png" alt="Editar" class="action-icon">
              <span>{{ column.actionLabel || 'Editar' }}</span>
            </button>
          </div>

          <!-- Tipo Status -->
          <div *ngSwitchCase="'status'" class="status-container">
            <span class="status-dot" [style.background-color]="getStatusColor(row[column.key])"></span>
            {{ formatStatus(row[column.key]) }}
          </div>

          <!-- Default (Text) -->
          <div *ngSwitchDefault [class.truncated-cell]="column.truncate">
            <span [class.truncated-cell-text]="column.truncate">
              {{ formatCellValue(column.key, row[column.key]) }}
            </span>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <!-- Coluna de Ações -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button
          mat-stroked-button
          class="view-button"
          (click)="onViewButtonClick(row)"
          appTrackClick
          [trackEvent]="getTrackingEvent(row)"
          [trackCategory]="getTrackingCategory()"
          [trackLabel]="getTrackingLabel(row)"
          [trackValue]="getTrackingValue(row)">
          <img src="assets/icons/eyeIcon.png" alt="Visualizar" class="button-icon">
          {{ actionButtonLabel }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- Paginação -->
  <div class="pagination-container">
    <div class="pagination-content">
      <!-- Seletor de linhas por página -->
      <div class="rows-per-page">
        <label>Linhas por página:</label>
        <select class="page-selector" (change)="onPageSizeChange($event)" [value]="serverSidePagination ? serverSidePagination.pageSize : pageSize" [disabled]="loading">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      <!-- Contador de elementos -->
      <div class="page-counter">
        {{ getDisplayedRange() }}
      </div>

      <!-- Navegação -->
      <div class="navigation">
        <button class="nav-button" (click)="previousPage()" [disabled]="!hasPreviousPage() || loading">
          <img src="assets/icons/arrowBack.png" alt="Anterior" class="nav-icon">
        </button>
        <button class="nav-button" (click)="nextPage()" [disabled]="!hasNextPage() || loading">
          <img src="assets/icons/arrowNext.png" alt="Próxima" class="nav-icon">
        </button>
      </div>
    </div>
  </div>
</div>
